<template>
    <div class="custom-page">
        <component v-if="show_not_found" :is="`not-found`"></component>
        <default v-else :title="title" :wrap-content="true">
            <template slot="content">
                <div v-if="city_images.length" class="row content no-select">
                    <div class="col-xs-12 col-sm-8">
                        <div class="content" v-html="content"></div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="city-image" v-for="(val, key) in city_images" :key="key">
                            <img class="img-responsive" :src="val">
                        </div>
                    </div>
                </div>
                <div v-else class="content no-select" v-html="content"></div>
            </template>
        </default>
    </div>
</template>

<script>
	import CustomPage from '@views/public/pages/CustomPage/custom_page'
	import NotFound from '@theme-views/public/pages/NotFound'
	import Default from '@theme-views/public/layouts/Default'
	
	export default {
        mixins: [CustomPage],
        components: {
            Default,
            NotFound
        }
    }
</script>

<style lang="scss">
.custom-page {
    .addres-image-con {
        max-width: 280px;
        padding-bottom: 20px;
    }
}
</style>